const t = "_textContainer_17l3b_1", o = "_closeButton_17l3b_13", n = "_notificationContainer_17l3b_24", _ = "_inverted_17l3b_32", s = "_isInStackFromTop_17l3b_50", e = "_isInStackFromBottom_17l3b_53", c = "_root_17l3b_57", i = "_noLeftIcon_17l3b_72", a = "_hasActions_17l3b_75", l = "_hasCloseButton_17l3b_81", r = "_container_17l3b_81", b = "_actionsContainer_17l3b_92", p = "_hasCtas_17l3b_109", f = "_leftIcon_17l3b_135", u = "_twoLiner_17l3b_166", h = "_hasLeftIcon_17l3b_169", y = "_fullWidthActions_17l3b_173", C = {
  textContainer: t,
  closeButton: o,
  notificationContainer: n,
  inverted: _,
  isInStackFromTop: s,
  isInStackFromBottom: e,
  root: c,
  noLeftIcon: i,
  hasActions: a,
  hasCloseButton: l,
  "in-line-layout": "_in-line-layout_17l3b_81",
  container: r,
  "primary-type": "_primary-type_17l3b_84",
  "error-type": "_error-type_17l3b_88",
  actionsContainer: b,
  "warning-type": "_warning-type_17l3b_95",
  "success-type": "_success-type_17l3b_102",
  hasCtas: p,
  "top-page-layout": "_top-page-layout_17l3b_118",
  leftIcon: f,
  twoLiner: u,
  hasLeftIcon: h,
  fullWidthActions: y
};
export {
  b as actionsContainer,
  o as closeButton,
  r as container,
  C as default,
  y as fullWidthActions,
  a as hasActions,
  l as hasCloseButton,
  p as hasCtas,
  h as hasLeftIcon,
  _ as inverted,
  e as isInStackFromBottom,
  s as isInStackFromTop,
  f as leftIcon,
  i as noLeftIcon,
  n as notificationContainer,
  c as root,
  t as textContainer,
  u as twoLiner
};
//# sourceMappingURL=index.es754.js.map
